async function openCartDrawerPopup(event) {
    if (event) {
        event.preventDefault();
    }
    const cartDrawer = document.querySelector(".js-cart-drawer");
    const cartOverlay = document.querySelector(".js-cart-overlay");

    cartDrawer.classList.add("is-active");
    cartOverlay.classList.add("is-active");
    document.body.classList.add("no-scroll");
    
    await refreshCart();
}

function closeCartDrawer() {
    const cartDrawer = document.querySelector(".js-cart-drawer");
    const cartOverlay = document.querySelector(".js-cart-overlay");

    cartDrawer.classList.remove("is-active");
    cartOverlay.classList.remove("is-active");
    document.body.classList.remove("no-scroll");
    document.querySelector(".empty-cart-message").style.display = "none";

}

// Add loader control functions
function showCartLoader() {
    const loader = document.querySelector('.cart-drawer__loader');
    if (loader) loader.style.display = 'flex';
}

function hideCartLoader() {
    const loader = document.querySelector('.cart-drawer__loader');
    if (loader) loader.style.display = 'none';
}

// Add this new function to check conditions
function updateFreeProductVisibility(cartData) {
    const freeProductSection = document.querySelector('.free-products');
    if (!freeProductSection) return;

    const qualifyingHandles = ['bow-wow-buddy', 'bully-sticks', 'collagen-sticks', 'bow-wow-buddy-starter-kit'];
    const freeProductHandle = 'dental-care-starter-kit-large';

    // Check if any qualifying product is in cart
    const hasQualifyingProduct = cartData.items.some(item => qualifyingHandles.includes(item.handle));
    
    // Check if free product is already in cart
    const hasFreeProduct = cartData.items.some(item => item.handle === freeProductHandle);

    // Show/hide free product section based on conditions
    if (hasQualifyingProduct && !hasFreeProduct) {
        // freeProductSection.style.display = 'block';
        freeProductSection.style.display = 'none';
    } else {
        freeProductSection.style.display = 'none';
    }
}

// Modify the refreshCart function to include the new visibility check
async function refreshCart() {
    showCartLoader();
    try {
        const response = await fetch('/cart.js');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const cartData = await response.json();
        console.log('cartData', cartData);
        
        // Update cart counters
        const cartCounters = document.querySelectorAll('.cart-counter');
        cartCounters.forEach(counter => {
            counter.textContent = cartData.item_count;
        });

        // Update upsell visibility
        updateUpsellVisibility(cartData);
        
        // Add this line to update free product visibility
        updateFreeProductVisibility(cartData);

        const lineItemsContainer = document.querySelector(".drawer-line-items-wrap");
        const subtotalElement = document.querySelector(".subtotal-text");
        const emptyCartMessage = document.querySelector(".empty-cart-message");
        const cartContent = document.querySelector(".cart-drawer__content");
        const cartFooter = document.querySelector(".cart-drawer__footer");

        if (cartData.items.length === 0) {
            emptyCartMessage.style.display = "flex";
            cartContent.style.display = "none";
            cartFooter.style.display = "none";
        } else {
            emptyCartMessage.style.display = "none";
            cartContent.style.display = "block";
            cartFooter.style.display = "block";

            lineItemsContainer.innerHTML = "";

            cartData.items.forEach((item) => {
                let lineItemHTML = `
                    <div class="line-item shadow-1" data-id="${item.id}">
                        <img src="${item.image}" alt="${item.title}" class="line-item__image">
                        <div class="line-item__details">
                            <h4 class="line-item__title">${item.product_title}</h4>
                            ${item.variant_title ?
                    `<p class="line-item__variant"><span class="line-item__variant-option">${item.variant_title}</span></p>`
                    : ''
                }
                            ${item.selling_plan_allocation ?
                    `<small class='selling-plan'>${item.selling_plan_allocation.selling_plan.name}</small>`
                    : ''
                }
                            <div class="priceNquantity">
                                ${item.handle === '4-in-1-toothbrush' ? 
                                    `<div class="">
                                    </div>` 
                                    : 
                                    `<div class="line-item__quantity">
                                        <button class="line-item__quantity-decrease">−</button>
                                        <span class="line-item__quantity-value">${item.quantity}</span>
                                        <button class="line-item__quantity-increase">+</button>
                                    </div>`
                                }
                                <div class="line-item__price-wrapper">
                                    ${item.original_line_price != item.final_line_price ? `<p class="line-item__price line-item__price--compare">$${(item.original_line_price / 100).toFixed(2)}</p>` : ''}
                                    <p class="line-item__price">$${(item.final_line_price / 100).toFixed(2)}</p>
                                </div>
                            </div>
                            <div class="line-item__discount-message mt-2">
                                ${item.total_discount > 0 ?
                    `<p class="discount-text">${item.discounts[0].title}</p>`
                    : ''}
                            </div>
                        </div>
                        <button class="line-item__remove" aria-label="Remove item" onclick="removeFromCart('${item.id}')">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 14" height="1em" width="1em">
                                <path d="M.887 3.402c0 .16.13.291.291.291h.292v9.146c0 .64.52 1.161 1.16 1.161h7.627c.64 0 1.16-.52 1.16-1.16V3.692h.292c.161 0 .292-.13.292-.291v-.92c0-.64-.521-1.161-1.161-1.161H8.245V.29A.292.292 0 007.953 0H4.934a.292.292 0 00-.291.292V1.32H2.047c-.64 0-1.16.52-1.16 1.16v.92zm9.947 9.437a.578.578 0 01-.577.578H2.63a.578.578 0 01-.578-.578V3.693h8.781v9.146zM5.226.583h2.435v.738H5.226V.583zM1.47 2.482c0-.319.259-.578.577-.578h8.793c.318 0 .577.26.577.578v.628H1.47v-.628z" fill="currentColor"/>
                                <path d="M3.534 12.244c.16 0 .291-.13.291-.292V5.158a.292.292 0 10-.583 0v6.794c0 .16.13.291.292.291zm1.941 0c.161 0 .292-.13.292-.292V5.158a.292.292 0 10-.583 0v6.794c0 .16.13.291.291.291zm1.938 0a.29.29 0 00.291-.292V5.158a.292.292 0 10-.583 0v6.794c0 .16.13.291.292.291zm1.941 0c.161 0 .292-.13.292-.292V5.158a.292.292 0 10-.584 0v6.794c0 .16.13.291.292.291z" fill="currentColor"/>
                            </svg>
                        </button>
                    </div>`;

                const parser = new DOMParser();
                const doc = parser.parseFromString(lineItemHTML, "text/html");
                const lineItemElement = doc.body.firstChild;
                lineItemsContainer.appendChild(lineItemElement);
            });

            if (subtotalElement) {
                const subtotalPrice = (cartData.items_subtotal_price / 100).toFixed(2);
                subtotalElement.textContent = `$${subtotalPrice}`;
            }
        }

        return cartData;
    } catch (error) {
        console.error('Error refreshing cart:', error);
    } finally {
        hideCartLoader();
    }
}

async function updateCartItem(lineId, quantity) {
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: lineId,
                quantity: quantity
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cart = await response.json();
        
        const cartCounters = document.querySelectorAll('.cart-counter');
        cartCounters.forEach(counter => {
            counter.textContent = cart.item_count;
        });

        await refreshCart();

        const subtotalElement = document.querySelector(".subtotal-text");
        const checkoutSubtotalElement = document.querySelector("#cart-amount");
        if (subtotalElement) {
            subtotalElement.textContent = `$${(cart.items_subtotal_price / 100).toFixed(2)}`;
        }
        if (checkoutSubtotalElement) {
            checkoutSubtotalElement.textContent = `$${(cart.items_subtotal_price / 100).toFixed(2)}`;
        }

        if (cart.item_count === 0) {
            document.querySelector('.empty-cart-message').style.display = 'flex';
            document.querySelector('.cart-drawer__content').style.display = 'none';
            document.querySelector('.cart-drawer__footer').style.display = 'none';
        }

    } catch (error) {
        console.error('Error updating cart item:', error);
    }
}

async function handleQuantityIncrease(button) {
    const lineItem = button.closest('.line-item');
    const lineItemId = lineItem.dataset.id;
    const quantityElement = lineItem.querySelector('.line-item__quantity-value');
    let quantity = parseInt(quantityElement.textContent, 10);

    quantity++;
    quantityElement.textContent = quantity;
    //commented out for now to prevent double loader issue
    // await refreshCart();
    updateCartItem(lineItemId, quantity);
}

function handleQuantityDecrease(button) {
    const lineItem = button.closest('.line-item');
    const lineItemId = lineItem.dataset.id;
    const quantityElement = lineItem.querySelector('.line-item__quantity-value');
    let quantity = parseInt(quantityElement.textContent, 10);

    if (quantity > 1) {
        quantity--;
        quantityElement.textContent = quantity;
        updateCartItem(lineItemId, quantity);
    } else {
        updateCartItem(lineItemId, 0);
    }
}

function handleRemoveItem(button) {
    const lineItem = button.closest('.line-item');
    const lineItemId = lineItem.dataset.id;
    updateCartItem(lineItemId, 0);
}

document.addEventListener('click', (event) => {
    if (event.target.classList.contains('line-item__quantity-increase')) {
        handleQuantityIncrease(event.target);
    }
    if (event.target.classList.contains('line-item__quantity-decrease')) {
        handleQuantityDecrease(event.target);
    }
    if (event.target.classList.contains('line-item__remove')) {
        handleRemoveItem(event.target);
    }
});

document.addEventListener('DOMContentLoaded', function() {
    refreshCart();

    const cartIcons = document.querySelectorAll(".cs-header__cart-btn");
    cartIcons.forEach(icon => {
        icon.addEventListener("click", async function(e) {
            e.preventDefault();
            await openCartDrawerPopup();
        });
    });

    document.querySelector(".js-close-cart-drawer").addEventListener("click", closeCartDrawer);
    document.querySelector(".js-cart-overlay").addEventListener("click", closeCartDrawer);

    // Set initial variant IDs for all add buttons
    const addButtons = document.querySelectorAll('.upsell-cart__add-btn');
    addButtons.forEach(button => {
        if (!button.dataset.variantId) {
            // Find the variant selector in the same container
            const variantSelector = button.closest('.upsell-cart__item').querySelector('.upsell-cart__variant-selector');
            if (variantSelector) {
                // Set the first available variant
                const firstAvailableOption = Array.from(variantSelector.options).find(option => !option.disabled);
                if (firstAvailableOption) {
                    button.setAttribute('data-variant-id', firstAvailableOption.value);
                }
            }
        }
    });

    // Handle variant selection
    const variantSelectors = document.querySelectorAll('.upsell-cart__variant-selector');
    variantSelectors.forEach(selector => {
        selector.addEventListener('change', function() {
            const selectedOption = this.options[this.selectedIndex];
            const addButton = this.closest('.upsell-cart__item').querySelector('.upsell-cart__add-btn');
            if (addButton) {
                addButton.setAttribute('data-variant-id', this.value);
                
                // Update price display if needed
                const priceDisplay = this.closest('.upsell-cart__item').querySelector('.price');
                if (priceDisplay && selectedOption.dataset.price) {
                    priceDisplay.textContent = selectedOption.dataset.price;
                }
            }
        });

        // Set initial variant on load
        const event = new Event('change');
        selector.dispatchEvent(event);
    });

    // Handle add to cart
    addButtons.forEach(button => {
        button.addEventListener('click', async function() {
            showCartLoader();
            const variantId = this.getAttribute('data-variant-id');
            if (!variantId) {
                hideCartLoader();
                return;
            }
            
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: [{
                            id: variantId,
                            quantity: 1
                        }]
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const cartData = await response.json();
                
                // Update upsell visibility
                updateUpsellVisibility(cartData);
                
                // Refresh cart drawer
                await refreshCart();
                
                // Show success message
                this.textContent = 'Added!';
                setTimeout(() => {
                    this.textContent = 'Add';
                }, 2000);

            } catch (error) {
                console.error('Error:', error);
                this.textContent = 'Error - Try Again';
            } finally {
                hideCartLoader();
            }
        });
    });

    // Handle free product functionality
    const freeProductVariantSelector = document.querySelector('.free-product__variant-selector select');
    const freeProductAddButton = document.querySelector('.free-product__add-btn');

    if (freeProductVariantSelector && freeProductAddButton) {

        freeProductAddButton.setAttribute('data-variant-id', freeProductVariantSelector.value);

        freeProductVariantSelector.addEventListener('change', function() {
            freeProductAddButton.setAttribute('data-variant-id', this.value);
        });

        // Handle add to cart
        freeProductAddButton.addEventListener('click', async function(e) {
            e.preventDefault();
            showCartLoader();
            
            const variantId = this.getAttribute('data-variant-id');
            if (!variantId) {
                hideCartLoader();
                return;
            }
            
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        items: [{
                            id: variantId,
                            quantity: 1,
                            properties: {
                                '_free_product': 'true'
                            }
                        }]
                    })
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const cartData = await response.json();
                
                // Refresh cart drawer
                await refreshCart();
                
                // Show success message
                this.textContent = 'Added!';
                setTimeout(() => {
                    this.textContent = 'Add';
                }, 2000);

            } catch (error) {
                console.error('Error:', error);
                this.textContent = 'Error - Try Again';
            } finally {
                hideCartLoader();
            }
        });
    }
});

async function removeFromCart(lineId) {
    showCartLoader();
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: lineId,
                quantity: 0
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cart = await response.json();
        
        const cartCounters = document.querySelectorAll('.cart-counter');
        cartCounters.forEach(counter => {
            counter.textContent = cart.item_count;
        });

        // lineItem.remove();
        await refreshCart();

        const subtotalElement = document.querySelector(".subtotal-text");
        const checkoutSubtotalElement = document.querySelector("#cart-amount");
        if (subtotalElement) {
            subtotalElement.textContent = `$${(cart.items_subtotal_price / 100).toFixed(2)}`;
        }
        if (checkoutSubtotalElement) {
            checkoutSubtotalElement.textContent = `$${(cart.items_subtotal_price / 100).toFixed(2)}`;
        }

        if (cart.item_count === 0) {
            document.querySelector('.empty-cart-message').style.display = 'flex';
            document.querySelector('.cart-drawer__content').style.display = 'none';
            document.querySelector('.cart-drawer__footer').style.display = 'none';
        }

    } catch (error) {
        console.error('Error removing item from cart:', error);
    } finally {
        hideCartLoader();
    }
}

document.addEventListener('click', function(event) {
    if (event.target.classList.contains('line-item__remove')) {
        event.preventDefault();
        const lineItem = event.target.closest('.line-item');
        if (lineItem) {
            const lineId = lineItem.dataset.id;
            removeFromCart(lineId);
        }
    }
});

document.addEventListener('cart:updated', function(event) {
    refreshCart();
});

function updateUpsellVisibility(cartData) {
    const upsellItems = document.querySelectorAll('.upsell-cart__item');
    let visibleCount = 0;
    const maxDisplay = 3;
    
    // First, handle visibility based on cart contents
    upsellItems.forEach(upsellItem => {
        const productId = upsellItem.querySelector('.upsell-cart__add-btn').dataset.productId;
        const isInCart = cartData.items.some(item => item.product_id.toString() === productId);
        
        if (isInCart) {
            upsellItem.style.display = 'none';
        } else {
            // Show item only if we haven't reached max display count
            if (visibleCount < maxDisplay) {
                upsellItem.style.display = 'block';
                upsellItem.classList.remove('hidden');
                visibleCount++;
            } else {
                upsellItem.style.display = 'none';
                upsellItem.classList.add('hidden');
            }
        }
    });

    // Hide "Don't Forget" section if no visible upsells
    const upsellSection = document.querySelector('.upsell-cart');
    if (upsellSection) {
        upsellSection.style.display = visibleCount > 0 ? 'block' : 'none';
    }
}

async function handleQuantityUpdate(lineId, newQuantity) {
    showCartLoader();
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: lineId,
                quantity: newQuantity
            })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const cartData = await response.json();
        
        // Update cart counter
        const cartCounters = document.querySelectorAll('.cart-counter');
        cartCounters.forEach(counter => {
            counter.textContent = cartData.item_count;
        });

        // Update upsell visibility
        updateUpsellVisibility(cartData);

        return cartData;
    } catch (error) {
        console.error('Error updating quantity:', error);
    } finally {
        hideCartLoader();
    }
}